if($('.news-page').length) {



    $('.see-more-photos').click(function () {
        var images = $(this).next().find('img').map(function(){
            return $(this).attr('src')
        }).get();

        console.log(images);

        $('.news-page').append('<div class="full-page-slider"></div>');

        for (i=0; i < images.length; i++) {
            $('.full-page-slider').append('<div><img src="'+images[i]+'" alt=""></div>');
        }
        $('.full-page-slider').slick({
            autoplay: false,
            draggable: true,
            fade: false,
            speed: 1000,
            arrows: true,
            dots: true,
            prevArrow: '<a href="javascript:;" class="arrow prev"></a>',
            nextArrow: '<a href="javascript:;" class="arrow next"></a>'
        });
        $('.full-page-slider').append('<span class="close"></span>');
        $('.full-page-slider').addClass('active');

        $('.full-page-slider .close').on('click',function () {
            $('.full-page-slider').removeClass('active');
            setTimeout(function () {
                $('.full-page-slider').remove();
            }, 500);
        });
    });

}